import * as React from 'react';
import { Menu, MenuItem, Divider, IconButton } from '@mui/material';

import { useSelector, useDispatch } from 'react-redux';
import { logout } from 'app/redux/actions/AuthActions';
//import { reset } from 'app/redux/actions/CounterActions';
import { useNavigate } from 'react-router-dom';
import Avatar from 'app/components/Avatar';
import Icon from 'app/components/Icon';
import ReactGA from "react-ga4";

export default function UserMenu({ source }) {
  const user = useSelector(store=>store.auth.user || {});
  const navigate = useNavigate();
  const dispatch = useDispatch();
   
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) =>setAnchorEl(event.currentTarget)
  const handleClose = (route) => {
    if( route ){
      if( route === 'logout'){
        ReactGA.event({category: "user", action: "logout" });
        dispatch({ type: 'RESET_COUNTER' });
        dispatch(logout());
        navigate('/');
      } else
        navigate('/'+route);
    }
    setAnchorEl(null);
  }
  
  return (
    <React.Fragment>
        <IconButton
          className="user-menu-btn"
          onClick={handleClick}
          size="small"
          aria-controls={open ? 'account-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
        >
        <Avatar url={user?.image} name={`${user?.firstname} ${user?.lastname}`} size={36} />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        className="user-menu"
        onClose={()=>handleClose()}
        onClick={()=>handleClose()}
        PaperProps={{ elevation: 0 }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        <MenuItem onClick={()=>handleClose('dashboard')}>
          <Icon>th</Icon>
          Dashboard
        </MenuItem>
      
        <Divider />
        <MenuItem onClick={()=>handleClose('profile/edit')}>
          <Icon>edit</Icon>
          Edit Profile
        </MenuItem>
      
        <MenuItem onClick={()=>handleClose('profile/changepassword')}>
          <Icon>key</Icon>
          Change Passoword
        </MenuItem>
        <MenuItem onClick={()=>handleClose('dashboard/settings')}>
          <Icon>cog</Icon>
          Settings
        </MenuItem>
        <Divider />
        <MenuItem onClick={()=>handleClose('logout')}>
          <Icon>sign-out</Icon>
          Logout
        </MenuItem>
      </Menu>
    </React.Fragment>
  );
}
